import { Component, Vue } from 'vue-property-decorator';
import { UnsavedChangesModalResult } from '@/models/ui/unsaved-changed-modal-result';

@Component
export default class UnsavedChangesModalComponent extends Vue {
    private resolver = null
    showUnsavedChangesModal = false
    unsavedChangesMessage = null

    async show(message: string): Promise<UnsavedChangesModalResult> {
        this.unsavedChangesMessage = message
        this.showUnsavedChangesModal = true

        const result = await new Promise<UnsavedChangesModalResult>((resolve, reject) => { this.resolver = resolve })

        this.showUnsavedChangesModal = false
        return result
    }

    cancelUnsavedChanged() {
        this.resolver(UnsavedChangesModalResult.Cancel)
    }

    discardUnsavedChanged() {
        this.resolver(UnsavedChangesModalResult.Discard)
    }

    applyUnsavedChanged() {
        this.resolver(UnsavedChangesModalResult.Apply)
    }
}
